<mat-toolbar>
  <span>
    {{'Fournisseurs' | uppercase}}
  </span>
</mat-toolbar>

<div class="content">
  <mat-form-field appearance="outline">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput [ngModel]="globalFilter" (ngModelChange)="applyFilter($event)" #input />
      @if (globalFilter) {
      <button matSuffix mat-icon-button class="close-button" aria-label="Clear"
        (click)="applyFilter(globalFilter = '')">
        <mat-icon>close</mat-icon>
      </button>
      }
  </mat-form-field>

  @if (filtersForm) {
    <form class="container-form-filter" [formGroup]="filtersForm">
      <mat-form-field appearance="outline">
        <mat-label>Enseigne</mat-label>
        <mat-select formControlName="enseigne">
            @for (enseigne of enseigneFilter; track enseigne) {
            <mat-option [value]="enseigne">
              {{ enseigne }}
            </mat-option>
            }
        </mat-select>
        @if (filtersForm.get('enseigne')!.value) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearEnseigneFilter($event)">
          <mat-icon>close</mat-icon>
        </button>
        }
      </mat-form-field>
       @if (filtersForm.get('enseigne')!.value && (globalFilter && globalFilter !== '')) {
        <button mat-raised-button (click)="clearAllFilters()" class="reset-button" color="primary">
          <span>Supprimer les filtres</span>
          <mat-icon>close</mat-icon>
        </button>
        }
    </form>
    }

    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <!-- Libellé Column -->
      <ng-container matColumnDef="libelle">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Libellé </th>
        <td mat-cell *matCellDef="let element"> {{element.libelle}} </td>
      </ng-container>

      <!-- Enseigne Column -->
      <ng-container matColumnDef="enseigne">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Enseigne </th>
        <td mat-cell *matCellDef="let element"> {{element.enseigne}} </td>
      </ng-container>

      <!-- Identifiant Column -->
      <ng-container matColumnDef="idLaboEnseigne">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Identifiant </th>
        <td mat-cell *matCellDef="let element"> {{element.idLaboEnseigne}} </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button>
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row (click)="goToSupplierB2C(row)" (keypress)="goToSupplierB2C(row)"
        *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" colspan="12">Aucune donnée correspondant au filtre "{{input.value}}"</td>
      </tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons>
    </mat-paginator>
</div>